import { IDropdownOption } from "@fluentui/react";
import {
  IResponseMessage,
  LineItemType,
  QuotationInfo,
} from "../Quotation.types";
import { ICustomerInfo } from "../Common/Interfaces/ICustomerInfo";
import {
  ISignQuotationErrorState,
  ISignQuotationFormData,
} from "../Components/SignQuotationComponent/SignQuotationComponent.types";
import { IExtendedDiscountItem } from "../Components/AuthorizedDiscountComponent/AuthorizedDiscountComponent.types";
export const YES = "Yes";
export const NO = "No";
export const ADD_ACTION = "Add";
export const EDIT_ACTION = "Edit";
export const SELECT_ACTION = "Select";
export const NEW_ACTION = "New";
export const BILL_TO = "Bill To";
export const SHIP_TO = "Ship To";
export const ADDRESS = "Address";
export const CONTACT = "Contact";
export const PRICING_SUMMARY = "Pricing Summary";
export const ORDER_DETAILS = "Order Details";
export const DefaultTotalPages = 5;
export const DefaultCurrentPage = 1;
export const DefaultCurrentPageSize = 20;
export enum QuotationStatus {
  All = "All",
  Draft = "Draft",
  Confirmed = "Confirmed",
  Expired = "Expired",
  Cancelled = "Cancelled",
}

export const Items = [
  { key: "QLP-00001", text: "QLP-00001" },
  { key: "9A9-00481", text: "9A9-00481" },
  { key: "RJN-00014", text: "RJN-00014" },
  { key: "CIN-00003", text: "CIN-00003" },
  { key: "KGZ-00041", text: "KGZ-00041" },
  { key: "TNX-00001", text: "TNX-00001" },
  { key: "8PU-00018", text: "8PU-00018" },
];

export const ItemDetails = [
  {
    skuId: "QLP-00001",
    productName: "QLP-00001",
    quantity: 1,
    availableInventory: 100,
    unitPrice: 2000,
    msrp: 2000,
    discount: 0,
    discountPercent: 0,
    netAmount: 1500,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    effectiveTaxRate: 0,
    lineItemType: LineItemType.Add,
    discountReason: "",
    lineItemIndex: 0,
  },
  {
    lineItemId: "",
    skuId: "QLP-00002",
    productName: "QLP-00002",
    quantity: 2,
    availableInventory: 100,
    unitPrice: 2000,
    msrp: 2000,
    discount: 0,
    discountPercent: 0,
    netAmount: 1500,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    effectiveTaxRate: 0,
    lineItemType: LineItemType.Add,
    discountReason: "",
    lineItemIndex: 0,
  },
  {
    lineItemId: "",
    skuId: "CIN-00003",
    productName: "CIN-00003",
    quantity: 4,
    availableInventory: 100,
    unitPrice: 2000,
    msrp: 2000,
    discount: 0,
    discountPercent: 0,
    netAmount: 1500,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    effectiveTaxRate: 0,
    lineItemType: LineItemType.Add,
    discountReason: "",
    lineItemIndex: 0,
  },
  {
    lineItemId: "",
    skuId: "KGZ-00041",
    productName: "KGZ-00041",
    quantity: 2,
    availableInventory: 100,
    unitPrice: 2000,
    msrp: 2000,
    discountPercent: 0,
    discount: 0,
    netAmount: 1500,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    effectiveTaxRate: 0,
    lineItemType: LineItemType.Add,
    discountReason: "",
    lineItemIndex: 0,
  },
  {
    lineItemId: "",
    skuId: "TNX-00001",
    productName: "TNX-00001",
    quantity: 1,
    availableInventory: 100,
    unitPrice: 2000,
    msrp: 2000,
    discount: 0,
    discountPercent: 0,
    netAmount: 1500,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    effectiveTaxRate: 0,
    lineItemType: LineItemType.Add,
    discountReason: "",
    lineItemIndex: 0,
  },
  {
    lineItemId: "",
    skuId: "8PU-00018",
    productName: "8PU-00018",
    quantity: 1,
    availableInventory: 100,
    unitPrice: 2000,
    msrp: 2000,
    discount: 0,
    discountPercent: 0,
    netAmount: 1500,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    effectiveTaxRate: 0,
    lineItemType: LineItemType.Add,
    discountReason: "",
    lineItemIndex: 0,
  },
];

export const CustomerAccounts = [
  { key: "757fb152-6014-400b-b9ee-22ce2ae59d84", text: "2342345511007" },
  { key: "a1b8a7c9-ee72-4c65-a648-7b876f46c7de", text: "725481930" },
  { key: "3bb5b7fb-a894-4939-9825-676922ec0081", text: "0012829831823" },
  { key: "c0783db6-b9a9-4c28-958d-0a1bfd136e8b", text: "12312098903" },
  { key: "0b0d73c2-7b81-4700-bef8-68927343d0e2", text: "12341431001" },
];

export const DiscountTypes = [
  { key: "Percentage", text: "Percentage" },
  { key: "Amount", text: "Amount" },
];

export const PaymentOptions = [
  { key: "PrePaid", text: "PrePaid" },
  { key: "PostPaid", text: "PostPaid" },
];

export const PaymentMethods = [
  { key: "CreditCard", text: "Credit Card" },
  { key: "WireTransfer", text: "Wire Transfer" },
];

export const PaymentTerms = [
  { key: "N030", text: "Net 30 days" },
  { key: "N045", text: "Net 45 days" },
  { key: "N060", text: "Net 60 days" },
  { key: "N090", text: "Net 90 days" },
];

export const DeliveryOptions = [
  { key: "ST", text: "Ship from DC Ground" },
];

export const DeliveryReasons = [
  { key: "Commercial", text: "Commercial Direct Order" },
];

export const MSXOpportunityId = "7-TEDBHDVF4";

export const QuotationExpiryDays = "30";

export const PaymentErrorDefualtState = {
  adyenPaymentLink: false,
  invalidPaymentLink: false,
};

export const ErrorsDefaultState = {
  customerAccount: false,
  quotationNumber: false,
  expirationDate: "",
  msxOpportunityId: "",
  paymentType: "",
  paymentMethod: "",
  paymentTerms: "",
  customerPurchaseOrder: "",
  deliveryMode: "",
  deliveryReason: "",
  quoteLineItems: false,
  microsoftAccountEmail: "",
  microsoftAccountLead: "",
  microsoftAccountPhone: "",
  comments: "",
  preparedBy: "",
  lineItems: {
    quantity: false,
  },
  standaloneItems: false,
};

export const ItemErrorsDefaultState = {
  validItem: false,
  skuId: false,
  quantity: false,
};

export const DefaultItemFormData = {
  lineItemId: "",
  skuId: "",
  productName: "",
  quantity: 1,
  availableInventory: 0,
  reservedInventory: 0,
  unitPrice: 0,
  msrp: 0,
  netAmount: 0,
  discount: 0,
  discountPercent: 0,
  authorizedDiscount: 0,
  lineTotal: 0,
  lineTotalWithTax: 0,
  lineItemTax: 0,
  effectiveTaxRate: 0,
  levyFeeAmount: 0,
  totalLineLevyFeeAmount: 0,
  lineItemType: LineItemType.Add,
  discountReason: "",
  authDiscountType: DiscountTypes[0].key,
  authDiscountAmounts: [],
  authDiscountPercentages: [],
  lineItemIndex: 0,
  taxType: "",
};

export const DefaultItem = {
  productId: "",
  sapItemId: "",
  skuId: "",
  availabilityId: "",
  productTitle: "",
  availableInventory: 0,
  msrp: 0,
  discountedPrice: 0,
  isPreOrder: false,
  taxCode: "",
  discountedPercentage: 0,
  unitPrice: 0,
  authorizedDiscount: 0,
  netAmount: 0,
  lineTotal: 0,
  lineTotalWithTax: 0,
  lineItemTax: 0,
  discountReason: "",
  authDiscountType: DiscountTypes[0].key,
  authDiscountAmounts: [],
  authDiscountPercentages: [],
  lineItemIndex: 0,
  lineItemId: 0,
  quantity: 1,
};

export const CountriesData = [
  {
    countryName: "United States of America",
    countryCode: "USA",
    currency: "USD",
  },
  {
    countryName: "China",
    countryCode: "CHN",
    currency: "CNY",
  },
  {
    countryName: "Japan",
    countryCode: "JPN",
    currency: "JPY",
  },
  {
    countryName: "Germany",
    countryCode: "DEU",
    currency: "EUR",
  },
  {
    countryName: "France",
    countryCode: "FRA",
    currency: "EUR",
  },
  {
    countryName: "Singapore",
    countryCode: "SGP",
    currency: "SGD",
  },
  {
    countryName: "Spain",
    countryCode: "ESP",
    currency: "EUR",
  },
  {
    countryName: "Italy",
    countryCode: "ITA",
    currency: "EUR",
  },
  {
    countryName: "Austria",
    countryCode: "AUT",
    currency: "EUR",
  },
  {
    countryName: "Belgium",
    countryCode: "BEL",
    currency: "EUR",
  },
  {
    countryName: "Denmark",
    countryCode: "DNK",
    currency: "DKK",
  },
  {
    countryName: "Finland",
    countryCode: "FIN",
    currency: "EUR",
  },
  {
    countryName: "Ireland",
    countryCode: "IRL",
    currency: "EUR",
  },
  {
    countryName: "Luxembourg",
    countryCode: "LUX",
    currency: "EUR",
  },
  {
    countryName: "Netherlands",
    countryCode: "NLD",
    currency: "EUR",
  },
  {
    countryName: "New Zealand",
    countryCode: "NZL",
    currency: "NZD",
  },
  {
    countryName: "Norway",
    countryCode: "NOR",
    currency: "NOK",
  },
  {
    countryName: "Portugal",
    countryCode: "PRT",
    currency: "EUR",
  },
  {
    countryName: "Sweden",
    countryCode: "SWE",
    currency: "SEK",
  },
  {
    countryName: "Switzerland",
    countryCode: "CHE",
    currency: "CHF",
  },
];

export const CustomerData = {
  id: "001702d4-5a45-4375-a251-b01a5b532bc3",
  accountId: "168961622041358688",
  taxId: "88989",
  legalAccountId: "3333333",
  affilation: "Billing",
  authorizedBuyerFirstName: "Paras Buyer First Name",
  authorizedBuyerLastName: "Paras Buyer Last Name",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "+923210000000",
  authorizedEmailId: "paras@gmail.com",
  name: "Paras",
  purchasingCompanyTaxId: "Tax Id 12345",
  paymentTerms: "",
  shipmentCompanyTaxId: "",
  registerAddress: {
    addressId: "70b39b77-3221-4e46-ae8a-79384d28e862",
    affilation: "Registered Address",
    street: "Street 1",
    postalCode: "567300",
    city: "California",
    province: "New York",
    country: "United States of America",
    contactFirstName: "Paras First Name",
    contactLastName: "Paras Last Name",
    contactPhone: "+923210000001",
    contactEmail: "abcd2@gmail.com",
    addressName: "Paras",
    addressTaxId: "",
  },
  billingAddress: [
    {
      addressId: "8f22227d-af72-4d43-a070-cde4a9031a30",
      affilation: "Billing",
      street: "Street 2",
      postalCode: "576400",
      city: "ABC",
      province: "XYZ",
      country: "United States of America",
      contactFirstName: "Paras First Name",
      contactLastName: "Paras Last Name",
      contactPhone: "+923210000001",
      contactEmail: "abcd2@gmail.com",
      addressName: "Paras",
      addressTaxId: "",
    },
    {
      addressId: "8f22227d-af72-4d43-a070-cde4a9031a30",
      affilation: "Shipping",
      name: "Paras",
      street: "Street 3",
      postalCode: "576400",
      city: "ABC",
      province: "XYZ",
      country: "United States of America",
      contactFirstName: "Paras First Name",
      contactLastName: "Paras Last Name",
      contactPhone: "+923210000001",
      contactEmail: "abcd3@gmail.com",
      addressName: "Paras",
      addressTaxId: "",
    },
  ],
  shippingAddress: [
    {
      addressId: "8f22227d-af72-4d43-a070-cde4a9031a30",
      affilation: "Shipping",
      name: "Paras",
      street: "Street 4",
      postalCode: "576400",
      city: "ABC",
      province: "XYZ",
      country: "United States of America",
      contactFirstName: "Paras Buyer First Name",
      contactLastName: "Paras Buyer Last Name",
      contactPhone: "+923210000001",
      contactEmail: "abcd4@gmail.com",
      addressName: "Paras",
      addressTaxId: "",
    },
    {
      addressId: "8f22227d-af72-4d43-a070-cde4a9031a30",
      affilation: "Shipping",
      name: "Paras",
      street: "Street 5",
      postalCode: "576400",
      city: "ABC",
      province: "XYZ",
      country: "United States of America",
      contactFirstName: "Paras First Name",
      contactLastName: "Paras Last Name",
      contactPhone: "+923210000001",
      contactEmail: "abcd5@gmail.com",
      addressName: "Paras",
      addressTaxId: "",
    },
  ],
  country: "United States of America",
};

export const DefaultSkuData = {
  deviceType: "Bundle",
  standaloneDevices: [
    {
      productId: "8WG5VQP0X389",
      sapItemId: "QJX-00009",
      skuId: "L12P",
      availabilityId: "8SM8Q04LWDSK",
      productTitle: "Surface Pro Keyboard til virksomheder",
      availableInventory: 3,
      msrp: 159.95,
      discountedPrice: 0,
      isPreOrder: false,
      taxCode: "",
      taxType:"",
    },
    {
      productId: "8WG5VQP0X389",
      sapItemId: "QJX-00009",
      skuId: "34S3",
      availabilityId: "8NK47563KTST",
      productTitle: "Surface Pro Keyboard for Business",
      availableInventory: 3,
      msrp: 159.95,
      discountedPrice: 0,
      isPreOrder: true,
      taxCode: "",
      taxType:"",
    },
    {
      productId: "8WG5VQP0X389",
      sapItemId: "QJX-00009",
      skuId: "KKR1",
      availabilityId: "8QTZNWDDV4CK",
      productTitle: "Surface Pro Keyboard for Business",
      availableInventory: 3,
      msrp: 359.95,
      discountedPrice: 0,
      isPreOrder: false,
      taxCode: "",
      taxType:"",
    },
    {
      productId: "8WG5VQP0X389",
      sapItemId: "QJX-00009",
      skuId: "VGQ3",
      availabilityId: "941R1D1KR4L1",
      productTitle: "Surface Pro Keyboard for Business",
      availableInventory: 3,
      msrp: 459.95,
      discountedPrice: 0,
      isPreOrder: false,
      taxCode: "",
      taxType:"",
    },
    {
      productId: "8WG5VQP0X389",
      sapItemId: "QJX-00009",
      skuId: "ZCQL",
      availabilityId: "8QWNXH3L0GG4",
      productTitle: "Surface Pro Keyboard for Business",
      availableInventory: 3,
      msrp: 309.95,
      discountedPrice: 0,
      isPreOrder: true,
      taxCode: "",
      taxType:"",
    },
  ],
  bundles: [
    {
      bundleTitle: "BuyMGetN 1",
      bundleId: "8WG5VQP0X2Z3",
      bundleSlots: null,
    },
    {
      bundleTitle: "BuyMGetN 2",
      bundleId: "8WG5VQP0X2Z4",
      bundleSlots: null,
    },
    {
      bundleTitle: "BuyMGetN 3",
      bundleId: "8WG5VQP0X2Z5",
      bundleSlots: null,
    },
    {
      bundleTitle: "BuyMGetN 4",
      bundleId: "8WG5VQP0X2Z6",
      bundleSlots: null,
    },
  ],
  standaloneMessages: [],
  bundleMessages: [],
};

export const DefaultStandaloneItems = [
  {
    productId: "8WG5VQP0X389",
    sapItemId: "QJX-00009",
    skuId: "",
    availabilityId: "",
    productTitle: "Surface Pro Keyboard til virksomheder",
    availableInventory: 3,
    msrp: 159.95,
    discountedPrice: 0,
    isPreOrder: false,
    taxCode: "",
    discountedPercentage: 0,
    unitPrice: 0,
    authorizedDiscount: 0,
    netAmount: 0,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    discountReason: "",
    authDiscountAmounts: [],
    lineItemIndex: 0,
    lineItemId: 0,
    quantity: 1,
    taxType:"",
  },
  {
    productId: "8WG5VQP0X389",
    sapItemId: "QJX-00009",
    skuId: "VGQ3",
    availabilityId: "941R1D1KR4L1",
    productTitle: "Surface Pro Keyboard for Business",
    availableInventory: 3,
    msrp: 459.95,
    discountedPrice: 0,
    isPreOrder: false,
    taxCode: "",
    discountedPercentage: 0,
    unitPrice: 0,
    authorizedDiscount: 0,
    netAmount: 0,
    lineTotal: 0,
    lineTotalWithTax: 0,
    lineItemTax: 0,
    discountReason: "",
    authDiscountAmounts: [],
    lineItemIndex: 1,
    lineItemId: 0,
    quantity: 1,
    taxType:"",
  },
];

export const DefaultBundles = [
  {
    index: 0,
    bundleId: "8WG5VQP0X2Z3",
    bundleTitle: "BuyMGetN 1",
    startIndex: 0,
    count: 2,
  },
  {
    index: 1,
    bundleId: "8WG5VQP0X2Z3",
    bundleTitle: "BuyMGetN 1",
    startIndex: 2,
    count: 9,
  },
];

export const DefaultBundleItems = [
  {
    slotId: 0,
    maximum: 1,
    minimum: 1,
    slotDetails: [
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel® Evo™ Core i5 - WiFi, 8GB RAM, 512GB SSD",
        skuId: "0270",
        availabilityId: "8RTT5S2LN7DM",
        sapItemId: "EBQ-00010",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 3,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel Core i5 - LTE, 8GB RAM, 256GB SSD",
        skuId: "0520",
        availabilityId: "8MVXKQXKPQ9X",
        sapItemId: "EIG-00011",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 27,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel Core i5 - LTE, 8GB RAM, 128GB SSD",
        skuId: "0MPX",
        availabilityId: "93SZZ97XC73P",
        sapItemId: "EHL-00011",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 22,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Graphite, Intel® Evo™ Core i7 - WiFi, 16GB RAM, 512GB SSD",
        skuId: "1Q55",
        availabilityId: "8P49L6CQS52D",
        sapItemId: "8PY-00025",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 6,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel® Evo™ Core i7 - WiFi, 32GB RAM, 1TB SSD",
        skuId: "2Z00",
        availabilityId: "8XV1Z2XKKFJ3",
        sapItemId: "EFI-00010",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 7,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel® Evo™ Core i7 - WiFi, 16GB RAM, 512GB SSD",
        skuId: "3F17",
        availabilityId: "9193ZS3W0VTQ",
        sapItemId: "8PY-00010",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 0,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel® Evo™ Core i5 - WiFi, 16GB RAM, 256GB SSD",
        skuId: "3GX6",
        availabilityId: "8NWKMDLCNFZ0",
        sapItemId: "8PU-00010",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 501,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Graphite, Intel® Evo™ Core i5 - WiFi, 8GB RAM, 256GB SSD",
        skuId: "3LV1",
        availabilityId: "90J78308TL34",
        sapItemId: "8PR-00027",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 12,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel Core i5 - WiFi, 8GB RAM, 128GB SSD",
        skuId: "4HD3",
        availabilityId: "8WSJ565JCDDZ",
        sapItemId: "8PP-00011",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 0,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel Core i5 - LTE, 16GB RAM, 256GB SSD",
        skuId: "7WWT",
        availabilityId: "8S77RK87W595",
        sapItemId: "EIN-00011",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 35,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel® Evo™ Core i5 - WiFi, 8GB RAM, 256GB SSD",
        skuId: "83P5",
        availabilityId: "918C4R3515VW",
        sapItemId: "8PR-00011",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 5,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Graphite, Intel® Evo™ Core i7 - WiFi, 16GB RAM, 256GB SSD",
        skuId: "FKVH",
        availabilityId: "92SRZMFDCJ0X",
        sapItemId: "8PW-00026",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 2019,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Graphite, Intel® Evo™ Core i5 - WiFi, 16GB RAM, 256GB SSD",
        skuId: "GL34",
        availabilityId: "8X7GWVGWBHP2",
        sapItemId: "8PU-00025",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 2,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel® Evo™ Core i7 - WiFi, 16GB RAM, 1TB SSD",
        skuId: "H80N",
        availabilityId: "8RC3J9C82RXF",
        sapItemId: "EED-00010",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 0,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel Core i3 - WiFi, 8GB RAM, 128GB SSD",
        skuId: "JX27",
        availabilityId: "8MR1X9NFWBBT",
        sapItemId: "8PM-00010",
        tag: null,
        displayRank: 0,
        msrp: 1879.0,
        discountedPrice: 0,
        availableInventory: 1,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X2Z3",
        productTitle:
          "Surface Pro 8 for Business - Platinum, Intel Core i7 - LTE, 16GB RAM, 256GB SSD",
        skuId: "M5LL",
        availabilityId: "8W92RC9SVGFX",
        sapItemId: "EIV-00011",
        tag: null,
        displayRank: 0,
        msrp: 0,
        discountedPrice: 0,
        availableInventory: 0,
        taxCode: "COMPUTER",
      },
    ],
  },
  {
    slotId: 1,
    maximum: 1,
    minimum: 0,
    slotDetails: [
      {
        isPreOrder: false,
        productId: "8WG5VQP0X394",
        productTitle: "Microsoft 365 Business Standard (1-Year Subscription)",
        skuId: "8VS0",
        availabilityId: "8XPJZT3GVVCS",
        sapItemId: "KLQ-00648",
        tag: null,
        displayRank: 0,
        msrp: 279.0,
        discountedPrice: 0,
        availableInventory: 395,
        taxCode: "COMPUTER",
      },
    ],
  },
  {
    slotId: 2,
    maximum: 10,
    minimum: 0,
    slotDetails: [
      {
        isPreOrder: false,
        productId: "8WG5VQP0X38Z",
        productTitle: "Surface Slim Pen 2 for Business",
        skuId: "H2SZ",
        availabilityId: "93SVL22L7BZJ",
        sapItemId: "8WX-00005",
        tag: null,
        displayRank: 0,
        msrp: 199.95,
        discountedPrice: 0,
        availableInventory: 85,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X392",
        productTitle:
          "Microsoft® Surface Accy Project R COMM ASKU SC XZ/ZH/KO/TH Black Commercial 1 License Charger",
        skuId: "2QZT",
        availabilityId: "8XHFJJB7VS6H",
        sapItemId: "8X3-00007",
        tag: null,
        displayRank: 0,
        msrp: 59.95,
        discountedPrice: 0,
        availableInventory: 19,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X38X",
        productTitle: "Surface Pen - Ice Blue",
        skuId: "0LJG",
        availabilityId: "8NWF48343CKJ",
        sapItemId: "EYU-00053",
        tag: null,
        displayRank: 0,
        msrp: 159.95,
        discountedPrice: 0,
        availableInventory: 1,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X387",
        productTitle: "Surface Arc Mouse for Business",
        skuId: "3JPQ",
        availabilityId: "8Z69TRBQP83T",
        sapItemId: "FHD-00076",
        tag: null,
        displayRank: 0,
        msrp: 129.95,
        discountedPrice: 0,
        availableInventory: 0,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X387",
        productTitle: "Surface Arc Mouse for Business",
        skuId: "2T02",
        availabilityId: "8ML4TBBL55LH",
        sapItemId: "FHD-00066",
        tag: null,
        displayRank: 0,
        msrp: 129.95,
        discountedPrice: 0,
        availableInventory: 1,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X386",
        productTitle: "Surface Dock 2 for Business",
        skuId: "H933",
        availabilityId: "90JBH3D9D1ZP",
        sapItemId: "1GK-00009",
        tag: null,
        displayRank: 0,
        msrp: 469.95,
        discountedPrice: 0,
        availableInventory: 340,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X38H",
        productTitle: "Surface USB-C® Travel Hub for Business",
        skuId: "7H6K",
        availabilityId: "8NFGJQKGFKCZ",
        sapItemId: "1E4-00005",
        tag: null,
        displayRank: 0,
        msrp: 179.95,
        discountedPrice: 0,
        availableInventory: 1173,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X385",
        productTitle: "Surface Dial",
        skuId: "G0TM",
        availabilityId: "8N1MR50NW4QV",
        sapItemId: "2WR-00004",
        tag: null,
        displayRank: 0,
        msrp: 159.95,
        discountedPrice: 0,
        availableInventory: 14,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X38M",
        productTitle: "Surface Headphones 2+ for Business",
        skuId: "H3P8",
        availabilityId: "8TQL3BJN54C2",
        sapItemId: "3BS-00004",
        tag: null,
        displayRank: 0,
        msrp: 529.95,
        discountedPrice: 0,
        availableInventory: 501,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X393",
        productTitle: "Surface Pro Sleeve",
        skuId: "K6T4",
        availabilityId: "94HR98R4FB0G",
        sapItemId: "RWR-00005",
        tag: null,
        displayRank: 0,
        msrp: 77777.0,
        discountedPrice: 0,
        availableInventory: 10,
        taxCode: "COMPUTER",
      },
    ],
  },
  {
    slotId: 3,
    maximum: 9,
    minimum: 0,
    slotDetails: [
      {
        isPreOrder: false,
        productId: "8WG5VQP0X38B",
        productTitle:
          "Surface Pro Signature Keyboard with Slim Pen 2 for Business - Black",
        skuId: "48R6",
        availabilityId: "93H10GQ6GR9W",
        sapItemId: "8X8-00015",
        tag: null,
        displayRank: 0,
        msrp: 479.95,
        discountedPrice: 0,
        availableInventory: 391,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X352",
        productTitle: "Surface Pro Signature Keyboard for Business – Black ",
        skuId: "D932",
        availabilityId: "8ZHRQ3M9RVWJ",
        sapItemId: "8XB-00015",
        tag: null,
        displayRank: 0,
        msrp: 299.95,
        discountedPrice: 0,
        availableInventory: 46,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X352",
        productTitle: "Surface Pro Signature Keyboard for Business – Platinum",
        skuId: "MBG8",
        availabilityId: "8T7GQMBN2J7F",
        sapItemId: "8XB-00075",
        tag: null,
        displayRank: 0,
        msrp: 299.95,
        discountedPrice: 0,
        availableInventory: 7,
        taxCode: "COMPUTER",
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X350",
        productTitle:
          "Surface Pro Signature Keyboard with Fingerprint Reader for Business",
        skuId: "FVSV",
        availabilityId: "8ML6F8FXLJ32",
        sapItemId: "8XG-00015",
        tag: null,
        displayRank: 0,
        msrp: 329.95,
        discountedPrice: 0,
        availableInventory: 9,
        taxCode: "COMPUTER",
      },
    ],
  },
  {
    slotId: 4,
    maximum: 1,
    minimum: 0,
    slotDetails: [],
  },
];
export const InitialQuotationInfo: QuotationInfo = {
  quotationId: "",
  partitionKey: "",
  quotationNumber: "",
  quotationName: "",
  quotationDescription: "",
  quotationDate: "",
  expiryDate: "",
  preparedBy: "",
  customerRequestedPromiseDate: "",
  total: "",
  totalTax: "",
  subTotal: "",
  totalFee: "",
  customer: {} as ICustomerInfo,
  status: "",
  msxOpportunityId: "",
  paymentType: "",
  selectedPaymentType: {} as IDropdownOption,
  paymentMethod: "",
  selectedPaymentMethod: {} as IDropdownOption,
  paymentTerms: PaymentTerms[1].key as string,
  selectedPaymentTerms: PaymentTerms[1],
  adyenPaymentLink: "",
  customerPurchaseOrder: "",
  deliveryMode: DeliveryOptions[0].key as string,
  selectedDeliveryMode: DeliveryOptions[0],
  deliveryReason: DeliveryReasons[0].key as string,
  selectedDeliveryReason: DeliveryReasons[0],
  quoteCurrency: "",
  comments: "",
  microsoftAccountLead: "",
  microsoftAccountPhone: "",
  microsoftAccountEmail: "",
  createdBy: "",
  createdByName: "",
  modifiedById: "",
  modifiedByName: "",
  country: "",
  quoteLineItems: [],
  quoteLineItemsClone: [],
  standaloneItems: [],
  standaloneItemsClone: [],
  bundles: [],
  bundleItems: [],
  bundleItemsClone: [],
  skuData: {
    deviceType: "",
    bundles: [],
    standaloneDevices: [],
    standaloneMessages: [],
    bundleMessages: [],
  },
  searchedSku: "",
  taxExpirationDate:""
};

export const DefaultCustomerDiscounts = [
  {
    discountName: "Business General",
    minimumDiscountAmount: "",
  },
  {
    discountName: "Deal Reg",
    minimumDiscountAmount: "",
  },
  {
    discountName: "CO_OP Pricing",
    minimumDiscountAmount: "30%",
  },
  {
    discountName: "Special Pricing",
    minimumDiscountAmount: "",
  },
  {
    discountName: "Close Audiance",
    minimumDiscountAmount: "",
  },
];

export const InitialStateOfResponseMessage: IResponseMessage = {
  message: "",
  showMessage: false,
};

export const InitialSignQuotationFormData: ISignQuotationFormData = {
  quotationNumber: "",
  customerName: "",
  quotationSignatureDate: "",
  customerPurchaseOrderNumber: "",
  validatedQuotationAndCustomerPO: false,
};

export const InitialSignQuotationErrorState: ISignQuotationErrorState = {
  quotationId: false,
  quotationNumber: false,
  customerName: false,
  paymentType: false,
  customerPurchaseOrderNumber: false,
  quotationSignatureDate: false,
  validatedQuotationAndCustomerPO: false,
  lineItemDiscounts: false,
};

export const DiscountListItem: IExtendedDiscountItem = {
  expirationDate: "",
  isChecked: false,
  isEditable: false,
  authorizedDiscountError: false,
  authorizedDiscountDecimalError: false,
  minimumAuthorizedDiscountError: false,
  authorizedDiscountDateError: false,
  authorizedDiscountDateWarning: false,
  authorizedDiscountAmount: 0,
  authorizedDiscountPercentage: 0,
  minimumAuthorizedDiscountAmount: -1,
  authorizedDiscountReason: "",
  authorizedDiscountReasonObj: {
    key: "",
    text: "",
  },
  caluculatedMinimuimDiscount:-1,
};

export const discountSummaryResponse = {
  data: {
    code: 200,
    data: {
      totalMSRP: 77777.77,
      totalDiscountPercent: 0,
      totalDiscountAmount: 0,
      totalDiscountPrice: 0,
      discountedLineItems: [
        {
          sku: "KGZ-00041",
          productName: "Surface Mobile Mouse for Business",
          msrp: 77777.77,
          quantity: 2,
          taxType: "VAT",
          taxAmount: 29555.55,
          taxPercent: 19,
          feeAmount: 7.5,
          feePercent: 0,
          totalLineDiscount: 0,
          authDiscountAmounts: [
            {
              type: "Base",
              amount: 0,
              percent: 0,
            },
          ],
          lineDiscounts: {
            discountAmountPerUnit: 0,
            discountPricePerUnit: 0,
            totalDiscountAmount: 0,
            totalDiscountPrice: 0,
          },
          feeAndTaxes: {
            feePerUnit: 3.75,
            taxPerUnit: 29555.55,
            totalTaxAmount: 14777.775,
            totalFeeAmount: 7.5,
          },
        },
        {
          sku: "KGZ-00041",
          productName: "Surface Mobile Mouse for Business",
          msrp: 77777.77,
          quantity: 2,
          taxType: "VAT",
          taxAmount: 29555.55,
          taxPercent: 19,
          feeAmount: 7.5,
          feePercent: 0,
          totalLineDiscount: 0,
          authDiscountAmounts: [
            {
              type: "Base",
              amount: 0,
              percent: 0,
            },
            {
              type: "Bid Grid",
              amount: 0,
              percent: 0,
            },
            {
              type: "Discount for Edge",
              amount: 0,
              percent: 0,
            },
          ],
          lineDiscounts: {
            discountAmountPerUnit: 0,
            discountPricePerUnit: 0,
            totalDiscountAmount: 0,
            totalDiscountPrice: 0,
          },
          feeAndTaxes: {
            feePerUnit: 3.75,
            taxPerUnit: 29555.55,
            totalTaxAmount: 14777.775,
            totalFeeAmount: 7.5,
          },
        },
        {
          sku: "KGZ-00041",
          productName: "Surface Mobile Mouse for Business",
          msrp: 77777.77,
          quantity: 2,
          taxType: "VAT",
          taxAmount: 29555.55,
          taxPercent: 19,
          feeAmount: 7.5,
          feePercent: 0,
          totalLineDiscount: 0,
          authDiscountAmounts: [
            {
              type: "Base",
              amount: 0,
              percent: 0,
            },
            {
              type: "Discount for Edge",
              amount: 0,
              percent: 0,
            },
          ],
          lineDiscounts: {
            discountAmountPerUnit: 0,
            discountPricePerUnit: 0,
            totalDiscountAmount: 0,
            totalDiscountPrice: 0,
          },
          feeAndTaxes: {
            feePerUnit: 3.75,
            taxPerUnit: 29555.55,
            totalTaxAmount: 14777.775,
            totalFeeAmount: 7.5,
          },
        },
        {
          sku: "KGZ-00041",
          productName: "Surface Mobile Mouse for Business",
          msrp: 77777.77,
          quantity: 2,
          taxType: "VAT",
          taxAmount: 29555.55,
          taxPercent: 19,
          feeAmount: 7.5,
          feePercent: 0,
          totalLineDiscount: 0,
          authDiscountAmounts: [
            {
              type: "Base",
              amount: 0,
              percent: 0,
            },
            {
              type: "Discount for Edge",
              amount: 0,
              percent: 0,
            },
            {
              type: "Bid Grid",
              amount: 0,
              percent: 0,
            },
          ],
          lineDiscounts: {
            discountAmountPerUnit: 0,
            discountPricePerUnit: 0,
            totalDiscountAmount: 0,
            totalDiscountPrice: 0,
          },
          feeAndTaxes: {
            feePerUnit: 3.75,
            taxPerUnit: 29555.55,
            totalTaxAmount: 14777.775,
            totalFeeAmount: 7.5,
          },
        },
      ],
    },
    message: "success",
  },
};

export const DefaultEssentialBundleDiscount = {
  contractSelected: "Essential Bundle 20%",
  expirationDate: "",
  minimumDiscount: "",
};

export const DefaultBundleProduct = {
  deviceType: "Bundle",
  bundleId: "8WG5VQP0X2Z3",
  bundleTitle: "BuyMGetN 1",
  bundleItems: [
    [],
    [],
    [],
    [
      {
        isPreOrder: false,
        productId: "8WG5VQP0X38B",
        productTitle:
          "Surface Pro Signature Keyboard with Slim Pen 2 for Business - Black",
        skuId: "48R6",
        availabilityId: "93H10GQ6GR9W",
        sapItemId: "8X8-00015",
        tag: null,
        displayRank: 0,
        msrp: 479.95,
        discountedPrice: 0,
        availableInventory: 415,
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X352",
        productTitle: "Surface Pro Signature Keyboard for Business – Black ",
        skuId: "D932",
        availabilityId: "8ZHRQ3M9RVWJ",
        sapItemId: "8XB-00015",
        tag: null,
        displayRank: 0,
        msrp: 299.95,
        discountedPrice: 0,
        availableInventory: 693,
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X352",
        productTitle: "Surface Pro Signature Keyboard for Business – Platinum",
        skuId: "MBG8",
        availabilityId: "8T7GQMBN2J7F",
        sapItemId: "8XB-00075",
        tag: null,
        displayRank: 0,
        msrp: 299.95,
        discountedPrice: 0,
        availableInventory: 45,
      },
      {
        isPreOrder: false,
        productId: "8WG5VQP0X350",
        productTitle:
          "Surface Pro Signature Keyboard with Fingerprint Reader for Business",
        skuId: "FVSV",
        availabilityId: "8ML6F8FXLJ32",
        sapItemId: "8XG-00015",
        tag: null,
        displayRank: 0,
        msrp: 329.95,
        discountedPrice: 0,
        availableInventory: 13,
      },
    ],
    [],
  ],
};
